import { gql } from "@lytra/frontend-common/__generated__/gql";
import { useQuery } from "@apollo/client/react";
import { SALES_CONTACT_EMAIL_FALLBACK } from "@/lib/salesContact";

const IS_ASSISTANT_CHAT_ENABLED_QUERY = gql(`
  query IsAssistantChatEnabled {
    adminIsAssistantChatEnabled
  }
`);

const SALES_CONTACT_EMAIL_QUERY = gql(`
  query SalesContactEmail {
    adminGetEffectiveSetting(key: "sales_contact_email")
  }
`);

export function useAssistantChatFeature() {
  const { data, loading } = useQuery(IS_ASSISTANT_CHAT_ENABLED_QUERY, {
    fetchPolicy: "cache-first",
  });

  return {
    assistantChatEnabled: data?.adminIsAssistantChatEnabled ?? true,
    loading,
  };
}

export function useSalesContactEmail() {
  const { data, loading } = useQuery(SALES_CONTACT_EMAIL_QUERY, {
    fetchPolicy: "cache-first",
  });

  return {
    salesEmail: data?.adminGetEffectiveSetting ?? SALES_CONTACT_EMAIL_FALLBACK,
    loading,
  };
}
